'use client';
import type { FC } from 'react';
import { Skeleton } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { PATHS } from '@/config/paths';
import { CardAssetRecomendation } from '@/components/modules/CardAssetRecomendation';
import { WidgetContainer } from '@/components/modules/Widget/Container';
import { useGetAssetsOpportunities } from '@/modules/Asset/http/client/useGetAssetsOpportunities';
import { useInvest } from '@/contexts/InvestContext';

export const RecommendationsWidget: FC<RecommendationsWidgetProps> = ({
  title,
  showButtonLink = true,
}) => {
  const { selectAsset } = useInvest();
  const t = useT();

  const { data: recommendations = [], isFetching } = useGetAssetsOpportunities({
    limit: 10,
    page: 1,
  });

  if (!isFetching && !recommendations.length) {
    return <></>;
  }

  return (
    <WidgetContainer
      containerId="recommendations"
      buttonLink={showButtonLink ? PATHS.hubs.recommendation : undefined}
      title={title ?? t('widgets.RecommendationsWidget.title')}
      sliderProps={{ swiperGap: '50px', slidesGap: '30px' }}
    >
      {isFetching
        ? Array.from({ length: 5 }).map((_, idx) => (
            <Skeleton
              key={`home-recommendations-${idx}`}
              w="13.25rem"
              h="8.75rem"
              borderRadius="0.625rem"
            />
          ))
        : recommendations.map(
            ({ id, ticker, thumb, recommendation, title, subcategory }) => (
              <CardAssetRecomendation
                key={`${id}-${recommendation}`}
                id={id}
                name={title}
                recommendation={translation[recommendation] ?? 'neutral'}
                subcategory={subcategory}
                thumb={thumb}
                ticker={ticker}
                handleInvestIn={(asset) =>
                  selectAsset({ asset, openDrawer: true })
                }
              />
            )
          )}
    </WidgetContainer>
  );
};

const translation = {
  COMPRA: 'buy',
  VENDA: 'sell',
  MANTER: 'keep',
  NEUTRO: 'neutral',
} as const;

type RecommendationsWidgetProps = {
  title?: string;
  showButtonLink?: boolean;
};
